export const generateMonthCount = (start: any, end: any) => {
  let totalMonthsCount = 0;
  for (let i = start; i <= end; i++) {
    totalMonthsCount = totalMonthsCount + 12;
  }
  return totalMonthsCount;
};

export const  mergeCompareData=(data1:any, data2:any,type:string)=> {
  const firstDateInResponse2 = data2[0].date;

  // Step 2: Find the index of this date in response1
  const indexInResponse1 = data1.findIndex((item:any) => item.date === firstDateInResponse2);

  // Step 3: Check if a previous entry exists and, if so, get it
  if (indexInResponse1 > 0) {
    const previousEntry = data1[indexInResponse1 - 1];
    // Step 4: Prepend this previous entry to data2
    data2.unshift(previousEntry);
  }
  
 // Create a map of dates for the second dataset
 const data2Map = new Map();
 data2.forEach((item:any) => data2Map.set(item.date, item[type]));
 const mergedData = data1.map((item:any) => {
   return {
     date: item.date,
     value1: item[type],
     value2: data2Map.get(item.date) || null,
     value3: data2Map.get(item.date) !== null ? parseFloat(((data2Map.get(item.date) - item[type]) / item[type]) * 100 as any).toFixed(2) : null,
     value4: data2Map.get(item.date) !== null ? parseFloat((( item[type]-data2Map.get(item.date)) / data2Map.get(item.date)) * 100 as any).toFixed(2) : null // If no matching date in data2, set value2 as null // If no matching date in data2, set value2 as null
   };
 })

 return mergedData;
}

export const generateQuarterCount = (start: any, end: any) => {
  let totalMonthsCount = 0;
  for (let i = start; i <= end; i++) {
    totalMonthsCount = totalMonthsCount + 4;
  }
  return totalMonthsCount;
};

export const getInitialOptions = (city: string) => {
  return [
    `Why invest in ${city}?`,
    `What are the predicted Cumulative Home Sales for ${city}?`,
    `What is the expected PPSF Growth in ${city}?`,
    `What is the expected DOM in ${city}?`,
    `How does the Population Growth in ${city} look like?`,
    `Where is the closest Airport to ${city}?`,
    `Is ${city} an up-and-coming City?`
  ]
}


export const sortByDate = (data: any) => {
  return data.sort((a:any, b: any) => {
    // @ts-ignore
    return new Date(a.date) - new Date(b.date);
  })
}